<template>
  <div>
    <el-dialog
      :title="`Edit Teacher ID: ${postForm.number}`"
      :visible.sync="dialogEditVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <el-form ref="postForm" :model="postForm" :rules="rules" label-width="140px" class="demo-ruleForm">
        <div class="createPost-main-container">
          <el-row>
            <el-col :span="24">
              <el-form-item label="Name:" style="margin-bottom: 30px;" prop="name">
                <el-input v-model="postForm.name" style="width:50%;" class="filter-item" placeholder="Name" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Email:" style="margin-bottom: 30px;" prop="email">
                <el-input v-model="postForm.email" style="width:50%;" class="filter-item" placeholder="Email" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Phone:" style="margin-bottom: 30px;" prop="phone">
                <el-input v-model="postForm.phone" style="width:80%;" class="filter-item" placeholder="Phone" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Country:" style="margin-bottom: 20px;" prop="country">
                <el-select v-model="postForm.country">
                  <el-option
                    v-for="item in $parent.countries"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Time Zone:" style="margin-bottom: 20px;" prop="timezone">
                <el-select v-model="postForm.timezone">
                  <el-option
                    v-for="(item, key) in $parent.timezones"
                    :key="key"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Status:" style="margin-bottom: 20px;" prop="disabled">
                <el-select v-model="postForm.disabled">
                  <el-option
                    v-for="item in disableOpitons"
                    :key="item.value"
                    :label="item.label | uppercaseFirst"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button @click="resetData()">Cancel</el-button>
                <el-button type="danger" @click="onSaveEvent($event)">Save</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import UserResource from '@/api/user'
const userResource = new UserResource()

const defaultForm = {
  id: 0,
  number: '',
  name: '',
  email: '',
  phone: '',
  country: 999,
  timezone: null,
  disabled: 1
}
export default {
  name: 'EditDialog',
  props: {
    dialogEditVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    const validateName = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('Name filed is required.'))
      } else {
        if (value.length > 128) {
          callback(new Error('Reached maximum number of characters(128).'))
        } else {
          callback()
        }
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Phone filed is required.'))
      } else {
        callback()
      }
    }
    return {
      data: null,
      postForm: Object.assign({}, defaultForm),
      rules: {
        name: [{ validator: validateName }],
        phone: [{ validator: validatePhone }]
      },
      disableOpitons: [
        { 'value': 0, 'label': '通過' },
        { 'value': 1, 'label': '未通過' }
      ]
    }
  },
  methods: {
    open() {
      this.data = this.$parent.currentEditItem
      this.postForm.id = this.data.id
      this.postForm.number = this.data.number
      this.postForm.name = this.data.name
      this.postForm.email = this.data.email
      this.postForm.phone = this.data.phone
      this.postForm.country = this.data.countryId
      this.postForm.timezone = this.data.timezone
      this.postForm.disabled = this.data.disabled
    },
    onSaveEvent(event) {
      this.$refs.postForm.validate(valid => {
        if (!valid) {
          return false
        }
        this.sendData()
      })
    },
    async sendData() {
      console.log(this.postForm)
      const { data } = await userResource.updateTeacher(this.postForm.id, this.postForm)
      const actionTitle = 'Edit Teacher '
      if (data.code === 0) {
        this.$parent.dialogEditVisible = false
        this.reloadParentData()
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          this.$parent.errorCodeMessage[data.code]['message'],
          this.$parent.errorCodeMessage[data.code]['type']
        )
      } else {
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          this.$parent.errorCodeMessage[data.code]['message'],
          this.$parent.errorCodeMessage[data.code]['type']
        )
        return false
      }
    },
    handleClose(done) {
      this.resetData()
      this.$parent.dialogEditVisible = false
    },
    reloadParentData() {
      this.$parent.getList()
      this.resetData()
    },
    resetData() {
      this.$refs.postForm.resetFields()
      this.$parent.dialogEditVisible = false
    }
  }
}
</script>
